import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import UpgradeIcon from '@mui/icons-material/Upgrade';

import { SOY } from 'styles/theme/colors';
import SecondaryCta from 'components/Buttons/SecondaryCta';

const ButtonsTypography = styled(Typography)({
  color: SOY,
  fontWeight: '500',
  fontSize: '16px'
});

const ShareButton = ({ text }) => {
  const handleClick = async () => {
    const data = {
      text,
      url: undefined,
      title: ''
    };

    if (navigator.canShare(data)) {
      try {
        await navigator.share(data);
      } catch (error) {}
    }
  };

  return (
    <SecondaryCta
      handleClick={handleClick}
      sx={{ textTransform: 'none' }}
      label={
        <Box display="flex">
          <UpgradeIcon sx={{ fill: SOY }} />
          <ButtonsTypography variant="div">Share</ButtonsTypography>
        </Box>
      }
    />
  );
};

ShareButton.propTypes = {
  text: PropTypes.string.isRequired
};

export default ShareButton;
